import { render } from "./VideoTab.vue?vue&type=template&id=3206c2af&scoped=true"
import script from "./VideoTab.vue?vue&type=script&lang=js"
export * from "./VideoTab.vue?vue&type=script&lang=js"

import "./VideoTab.vue?vue&type=style&index=0&id=3206c2af&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3206c2af"]])

export default __exports__